var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4201 23.9974C13.5658 23.9795 11.4711 23.4066 9.47609 22.3836C7.47089 21.3554 5.7189 19.9998 4.1664 18.3885C2.86967 17.0432 1.75709 15.5623 0.941201 13.8589C0.324806 12.575 0.327365 11.3268 0.95399 10.0761C2.02053 7.94561 3.4963 6.12456 5.26875 4.54137C6.16649 3.73827 7.12305 3.01189 8.14355 2.36481C10.7984 0.681872 13.663 -0.21075 16.8242 0.0424581C18.5941 0.183129 20.2617 0.722794 21.8475 1.51567C23.8987 2.54129 25.6942 3.9173 27.2799 5.55932C28.5766 6.90464 29.6918 8.38297 30.523 10.0761C31.1855 11.4266 31.1445 12.7207 30.4821 14.0328C29.6611 15.6544 28.5792 17.0918 27.3234 18.3936C25.7863 19.987 24.0496 21.3273 22.0879 22.3605C20.1236 23.3913 18.0391 23.9744 15.4226 24L15.4201 23.9974ZM20.6582 12.0711C20.6377 11.754 20.6275 11.4368 20.5917 11.1197C20.3717 9.15794 19.2284 7.73844 17.2667 7.27295C16.0646 6.98649 14.8574 7.0223 13.6937 7.41873C12.6578 7.76913 11.8777 8.45202 11.3841 9.46485C10.8214 10.6209 10.7524 11.8358 10.9212 13.0609C11.1897 15.0098 12.4123 16.3066 14.287 16.7311C15.4712 16.9997 16.6554 16.9588 17.7987 16.5751C18.8371 16.2247 19.6121 15.5316 20.1057 14.5265C20.4894 13.7464 20.6351 12.9279 20.6607 12.0711H20.6582Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.bb1341d2af2fbad1268394b5360abff1.svg";
export { ForwardRef as ReactComponent };